// The Jimmy bg-scene sizer.
//
// Goal (per the spec): the bg-scene pattern is exactly
//   (image height + 200px) tall,
// positioned so its top edge is 100px above the man and its bottom edge
// is 100px below him.
//
// The scene atom (atoms/_stickyBgScene.twig) is rendered as a preceding
// sibling of the `.the-jimmy` block-anchor. .the-jimmy's inner padding
// (100px top + 100px bottom on desktop, 60px on mobile) already gives the
// "image + 200px" framing, so we use block.getBoundingClientRect().height
// as the pattern height.
//
// Positioning gotcha: .the-jimmy itself has a margin-top (40 desktop /
// 28 mobile) for visual breathing room outside the pattern. That margin
// collapses up through the wrapping .block-anchor, which pushes
// .the-jimmy's visual top down by that amount. The pattern, as a sibling
// of the block-anchor, does NOT share that collapse, so without
// compensation it lands above .the-jimmy.top by exactly that margin.
// We add the same margin-top to the pattern so its top sits flush with
// .the-jimmy.top (= 100px above the image), then offset margin-bottom by
// the same amount to keep the net flow contribution at zero.

const SELECTOR_BLOCK = '.the-jimmy'
const SELECTOR_PATTERN = '[data-scene-pattern]'
const SELECTOR_VIDEO = '[data-scene-video]'
const VIDEO_HEIGHT_VH = 100

function findSceneFor(block) {
    const anchor = block.closest('.block-anchor') || block
    let pattern = null
    let video = null
    let prev = anchor.previousElementSibling
    while (prev) {
        if (!video && prev.matches(SELECTOR_VIDEO)) video = prev
        else if (prev.matches(SELECTOR_PATTERN)) { pattern = prev; break }
        prev = prev.previousElementSibling
    }
    return { pattern, video }
}

function position(block) {
    const { pattern, video } = findSceneFor(block)
    if (!pattern || !video) return

    const h = Math.round(block.getBoundingClientRect().height)
    if (h <= 0) return

    // Compensate for .the-jimmy's own margin-top (40 desktop / 28 mobile)
    // which collapses through .block-anchor and isn't shared by the
    // pattern sibling. Without this the pattern lands `offset` px above
    // where it should.
    const computed = window.getComputedStyle(block)
    const offset = Math.round(parseFloat(computed.marginTop) || 0)

    pattern.style.height = `${h}px`
    pattern.style.marginTop = `${offset}px`
    pattern.style.marginBottom = `${-h - offset}px`
    video.style.marginTop = `${h}px`
    video.style.marginBottom = `calc(-${VIDEO_HEIGHT_VH}vh - ${h}px)`
}

const theJimmyBgScene = {
    init() {
        const block = document.querySelector(SELECTOR_BLOCK)
        if (!block) return

        const run = () => position(block)
        run()
        window.requestAnimationFrame(run)

        let resizeTimer
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(run, 150)
        })

        const img = block.querySelector('img')
        if (img && !img.complete) {
            img.addEventListener('load', run, { once: true })
        }
    },
}

export default theJimmyBgScene
